<div class="container-fluid">
  <div class="row">
    <nav
      #sidebarMenu
      id="sidebarMenu"
      class="sidenav col-md-3 col-lg-3 d-md-block bg-light {{ classSidebar }}"
    >
      <dq-filters2 (filterChange)="applyServerFilter($event)"></dq-filters2>
    </nav>

    <main #main id="main" class="col-md-12 pt-0 {{ classMain }}">
      <dq-utility-bar></dq-utility-bar>
      <div class="d-flex {{ classMap }}">
        <div><dq-map></dq-map></div>
        <div><dq-table></dq-table></div>
      </div>
    </main>
  </div>
</div>
